export const gwPaints = {
  'Blue Horror': {
    name: `Blue Horror`,
    color: '#9eb5ce',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Base-Corvus-Black-2019',
    type: 'Base',
  },
  'Hoeth Blue': {
    name: `Hoeth Blue`,
    color: '#4c78af',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Layer-Hoeth-Blue-2019',
  },
  'Lothern Blue': {
    name: `Lothern Blue`,
    color: '#2c9bcc',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Layer-Lothern-Blue-2019',
  },
  'Calgar Blue': {
    name: `Calgar Blue`,
    color: '#2a497f',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Layer-Calgar-Blue-2019',
  },
  'Teclis Blue': {
    name: `Teclis Blue`,
    color: '#3877bf',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Layer-Teclis-Blue-2019',
  },
  'Alaitoc Blue': {
    name: `Alaitoc Blue`,
    color: '#2f4f85',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Layer-Alaitoc-Blue-2019',
  },
  'Altdorf Guard Blue': {
    name: `Altdorf Guard Blue`,
    color: '#2d4696',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Layer-Altdorf-Guard-Blue-2019',
  },
  'Corax White': {
    name: `Corax White`,
    color: '#FFF',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Base-Corax-White-2019',
    type: 'Base',
  },
  'Grey Seer': {
    name: `Grey Seer`,
    color: '#a2a5a7',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Base-Grey-Seer-2019',
    type: 'Base',
  },
  'Gal Vorbak Red': {
    name: `Gal Vorbak Red`,
    color: '#4b213c',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Barak-Nar Burgundy': {
    name: `Barak-Nar Burgundy`,
    color: '#451636',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Screamer Pink': {
    name: `Screamer Pink`,
    color: '#7a0e44',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Daemonette Hide': {
    name: `Daemonette Hide`,
    color: '#655f81',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Phoenician Purple': {
    name: `Phoenician Purple`,
    color: '#440052',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Naggaroth Night': {
    name: `Naggaroth Night`,
    color: '#3b2b50',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Caledor Sky': {
    name: `Caledor Sky`,
    color: '#366699',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Macragge Blue': {
    name: `Macragge Blue`,
    color: '#0f3d7c',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Kantor Blue': {
    name: `Kantor Blue`,
    color: '#02134e',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Night Lords Blue': {
    name: `Night Lords Blue`,
    color: '#002b5c',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Stegadon Scale Green': {
    name: `Stegadon Scale Green`,
    color: '#06455d',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Lupercal Green': {
    name: `Lupercal Green`,
    color: '#002c2b',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Incubi Darkness': {
    name: `Incubi Darkness`,
    color: '#082e32',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Death Guard Green': {
    name: `Death Guard Green`,
    color: '#6d774d',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Deathworld Forest': {
    name: `Deathworld Forest`,
    color: '#556229',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Castellan Green': {
    name: `Castellan Green`,
    color: '#264715',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Death Korps Drab': {
    name: `Death Korps Drab`,
    color: '#3d4539',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Waaagh Flesh': {
    name: `Waaagh Flesh`,
    color: '#0b3b36',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Nocturne Green': {
    name: `Nocturne Green`,
    color: '#162a29',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Morghast Bone': {
    name: `Morghast Bone`,
    color: '#c0a973',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Zandri Dust': {
    name: `Zandri Dust`,
    color: '#988e56',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Steel Legion Drab': {
    name: `Steel Legion Drab`,
    color: '#584e2d',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Mournfang Brown': {
    name: `Mournfang Brown`,
    color: '#490f06',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Dryad Bark': {
    name: `Dryad Bark`,
    color: '#2b2a24',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Rakarth Flesh': {
    name: `Rakarth Flesh`,
    color: '#9c998d',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Ratskin Flesh': {
    name: `Ratskin Flesh`,
    color: '#a86648',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Bugmans Glow': {
    name: `Bugman's Glow`,
    color: '#804c43',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Catachan Flesh': {
    name: `Catachan Flesh`,
    color: '#442b25',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Abaddon Black': {
    name: `Abaddon Black`,
    color: '#000000',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Abaddon Black': {
    name: `Abaddon Black`,
    color: '#000000',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Grey Knights Steel': {
    name: `Grey Knights Steel`,
    color: '#b8c4cc',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
    metal: true,
  },
  'Iron Hands Steel': {
    name: `Iron Hands Steel`,
    color: '#b6aca5',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
    metal: true,
  },
  'Iron Warriors': {
    name: `Iron Warriors`,
    color: '#625f5c',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
    metal: true,
  },
  'Balthasar Gold': {
    name: `Balthasar Gold`,
    color: '#946347',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
    metal: true,
  },
  'Screaming Bell': {
    name: `Screaming Bell`,
    color: '#d0875b',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
    metal: true,
  },
  'Runelord Brass': {
    name: `Runelord Brass`,
    color: '#695844',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
    metal: true,
  },
  'Orruk Flesh': {
    name: `Orruk Flesh`,
    color: '#8cc276',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Hobgrot Hide': {
    name: `Hobgrot Hide`,
    color: '#a1812a',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Thondia Brown': {
    name: `Thondia Brown`,
    color: '#54302a',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/',
    type: 'Base',
  },
  'Nuln Oil': {
    name: `Nuln Oil`,
    color: '#484645',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Nuln-Oil-2019',
    type: 'Shade',
    patreon: false,
    shade: true,
  },
  'Casandora Yellow': {
    name: `Casandora Yellow`,
    color: '#f28f44',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Casandora-Yellow-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Fuegan Orange': {
    name: `Fuegan Orange`,
    color: '#792b0e',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Fuegan-Orange-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Carroburg Crimson': {
    name: `Carroburg Crimson`,
    color: '#8e576e',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Carroburg-Crimson-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Druchii Violet': {
    name: `Druchii Violet`,
    color: '#6b476e',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Druchii-Violet-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Drakenhof Nightshade': {
    name: `Drakenhof Nightshade`,
    color: '#001138',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Drakenhof-Nightshade-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Coelia Greenshade': {
    name: `Coelia Greenshade`,
    color: '#176963',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Coelia-Greenshade-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Biel-Tan Green': {
    name: `Biel-Tan Green`,
    color: '#36553e',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Biel-Tan-Green-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Athonian Camoshade': {
    name: `Athonian Camoshade`,
    color: '#727353',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Athonian-Camoshade-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Seraphim Sepia': {
    name: `Seraphim Sepia`,
    color: '#906945',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Seraphim-Sepia-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Agrax Earthshade': {
    name: `Agrax Earthshade`,
    color: '#412e20',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Agrax-Earthshade-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Reikland Fleshshade': {
    name: `Reikland Fleshshade`,
    color: '#8e6e57',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Shade-Reikland-Fleshshade-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Apothecary White': {
    name: `Apothecary White`,
    color: '#aac1d6',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Apothecary-White-2019',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  'Tesseract Glow': {
    name: `Tesseract Glow`,
    color: '#90f542',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Technical-Tesseract-Glow-2020',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
  None: {
    name: `None`,
    color: 'rgba(0,0,0,0)',
    company: 'Games Workshop',
    link: 'https://www.games-workshop.com/en-GB/Technical-Tesseract-Glow-2020',
    type: 'Shade',
    patreon: true,
    shade: true,
  },
};

export const paints = {
  blue: [
    gwPaints['Blue Horror'],
    gwPaints['Hoeth Blue'],
    gwPaints['Lothern Blue'],
    gwPaints['Calgar Blue'],
    gwPaints['Teclis Blue'],
    gwPaints['Alaitoc Blue'],
    gwPaints['Altdorf Guard Blue'],
    gwPaints['Night Lords Blue'],
    gwPaints['Macragge Blue'],
    gwPaints['Kantor Blue'],
    gwPaints['Caledor Sky'],
  ],
  turquoise: [
    gwPaints['Stegadon Scale Green'],
    { name: 'The Fang', color: '#405b71', company: 'Games Workshop' },
    { name: 'Ahriman Blue', color: '#00708a', company: 'Games Workshop' },
    {
      name: 'Thousand Sons Blue',
      color: '#00506f',
      company: 'Games Workshop',
    },
    { name: `Baharroth Blue`, color: '#54bdca', company: 'Games Workshop' },
    {
      name: `Temple Guard Blue`,
      color: '#239489',
      company: 'Games Workshop',
    },
    {
      name: `Ahriman Blue`,
      color: '#00708a',
      metal: true,
      company: 'Games Workshop',
    },
    { name: `Thunderhawk Blue`, color: '#396a70', company: 'Games Workshop' },
    { name: `Sotek Green`, color: '#0b6371', company: 'Games Workshop' },
  ],
  purple: [
    gwPaints['Naggaroth Night'],
    gwPaints['Phoenician Purple'],
    gwPaints['Daemonette Hide'],
    gwPaints['Screamer Pink'],
    gwPaints['Barak-Nar Burgundy'],
    gwPaints['Gal Vorbak Red'],
    { name: 'Fulgrim Pink', color: '#f3abca', company: 'Games Workshop' },
    {
      name: `Emperor's Children`,
      color: '#b74073',
      company: 'Games Workshop',
    },
    { name: `Pink Horror`, color: '#8e2757', company: 'Games Workshop' },
    { name: `Dechala Lilac`, color: '#b598c9', company: 'Games Workshop' },
    { name: `Kakophoni Purple`, color: '#8869ae', company: 'Games Workshop' },
    {
      name: `Genestealer Purple`,
      color: '#7658a5',
      company: 'Games Workshop',
    },
    { name: `Xereus Purple`, color: '#47125a', company: 'Games Workshop' },
  ],
  orange: [
    { name: 'Jokaero Orange', color: '#ed3814', company: 'Games Workshop' },
    {
      name: 'Troll Slayer Orange',
      color: '#f16c23',
      company: 'Games Workshop',
    },
    {
      name: 'Fire Dragon Bright',
      color: '#f4874e',
      company: 'Games Workshop',
    },
    { name: 'Squig Orange', color: '#a74d42', company: 'Games Workshop' },
    { name: 'Lugganath Orange', color: '#f69b82', company: 'Games Workshop' },
    { name: `Zamesi Desert`, color: '#d89d1b', company: 'Games Workshop' },
    { name: 'Averland Sunset', color: '#fbb81c', company: 'Games Workshop' },
    { name: 'Yriel Yellow', color: '#ffd900', company: 'Games Workshop' },
    { name: 'Phalanx Yellow', color: '#ffe200', company: 'Games Workshop' },
    {
      name: 'Flash Gitz Yellow',
      color: '#fff300',
      company: 'Games Workshop',
    },
    { name: 'Dorn Yellow', color: '#fff55a', company: 'Games Workshop' },
  ],
  grey: [
    gwPaints['Abaddon Black'],
    gwPaints['Dryad Bark'],
    {
      name: 'Corvus Black',
      color: '#171314',
      link: 'https://www.games-workshop.com/en-GB/Base-Corvus-Black-2019',
      company: 'Games Workshop',
      type: 'Base',
    },
    {
      name: 'White Scar',
      color: '#fff',
      link: 'https://www.games-workshop.com/en-GB/Layer-White-Scar-2019',
      company: 'Games Workshop',
    },
    { name: 'Death Korps Drab', color: '#3d4539', company: 'Games Workshop' },
    { name: 'Ulthuan Grey', color: '#c4ddd5', company: 'Games Workshop' },
    { name: 'Russ Grey', color: '#507085', company: 'Games Workshop' },
    { name: 'Slaanesh Grey', color: '#8b8893', company: 'Games Workshop' },

    { name: 'Grey Seer', color: '#a2a5a7', company: 'Games Workshop' },
    { name: 'Celestra Grey', color: '#8ba3a3', company: 'Games Workshop' },

    {
      name: 'Mechanicus Standard Grey',
      color: '#39484a',
      company: 'Games Workshop',
    },
    {
      name: 'Administratum Grey',
      color: '#989c94',
      company: 'Games Workshop',
    },
    { name: 'Dawnstone', color: '#697068', company: 'Games Workshop' },
    { name: 'Stormvermin Fur', color: '#6d655f', company: 'Games Workshop' },
    {
      name: 'Skavenblight Dinge',
      color: '#45413b',
      company: 'Games Workshop',
    },
    { name: 'Warpfiend Grey', color: '#66656e', company: 'Games Workshop' },
    { name: `Slaanesh Grey`, color: '#8b8893', company: 'Games Workshop' },
    { name: `Warpfiend Grey`, color: '#66656e', company: 'Games Workshop' },
    { name: 'Ulthuan Grey', color: '#c4ddd5', company: 'Games Workshop' },

    { name: `Eshin Grey`, color: '#484b4e', company: 'Games Workshop' },

    {
      name: `Pallid Wych Flesh`,
      color: '#caccbb',
      company: 'Games Workshop',
    },
    { name: `Deepkin Flesh`, color: '#a9b79f', company: 'Games Workshop' },
    { name: `Fenrisian Grey`, color: '#6d94b3', company: 'Games Workshop' },
    { name: `Russ Grey`, color: '#507085', company: 'Games Workshop' },
    {
      name: `Administratum Grey`,
      color: '#989c94',
      company: 'Games Workshop',
    },
    { name: `Dawnstone`, color: '#697068', company: 'Games Workshop' },
  ],
  green: [
    gwPaints['Orruk Flesh'],
    gwPaints['Nocturne Green'],
    gwPaints['Waaagh Flesh'],
    gwPaints['Castellan Green'],
    gwPaints['Deathworld Forest'],
    gwPaints['Death Guard Green'],
    gwPaints['Incubi Darkness'],
    gwPaints['Lupercal Green'],
    { name: 'Caliban Green', color: '#003d15', company: 'Games Workshop' },
    { name: 'Ionrach Skin', color: '#97a384', company: 'Games Workshop' },
    {
      name: 'Dark Angel',
      color: '#002e2a',
      company: 'Games Workshop',
    },
    { name: 'nurglingGreen', color: '#7e975e', company: 'Games Workshop' },
    { name: 'orrukFlesh', color: '#8cc276', company: 'Games Workshop' },
    {
      name: `Gauss Blaster Green`,
      color: '#7fc1a5',
      company: 'Games Workshop',
    },
    { name: `Sybarite Green`, color: '#17a166', company: 'Games Workshop' },
    { name: `Kabalite Green`, color: '#008962', company: 'Games Workshop' },
    { name: `Nurgling Green`, color: '#7e975e', company: 'Games Workshop' },
    { name: `Elysian Green`, color: '#6b8c37', company: 'Games Workshop' },
    { name: `Ogryn Camo`, color: '#96a648', company: 'Games Workshop' },
    { name: `Straken Green`, color: '#597f1c', company: 'Games Workshop' },
    { name: `Loren Forest`, color: '#486c25', company: 'Games Workshop' },
    {
      name: `Sons of Horus Green`,
      color: '#00545e',
      company: 'Games Workshop',
    },
    { name: `Vulkan Green`, color: '#223c2e', company: 'Games Workshop' },
    { name: `Skarsnik Green`, color: '#588f6b', company: 'Games Workshop' },
    { name: `Moot Green`, color: '#3daf44', company: 'Games Workshop' },
    { name: `Warboss Green`, color: '#317e57', company: 'Games Workshop' },
    { name: `Warpstone Glow`, color: '#0f702a', company: 'Games Workshop' },
    { name: `Dark Reaper`, color: '#354d4c', company: 'Games Workshop' },
    { name: `Screaming Skull`, color: '#b9c099', company: 'Games Workshop' },
  ],
  brown: [
    { name: 'Rhinox Hide', color: '#462f30', company: 'Games Workshop' },
    gwPaints['Thondia Brown'],
    gwPaints['Hobgrot Hide'],
    gwPaints['Catachan Flesh'],
    gwPaints['Bugmans Glow'],
    gwPaints['Ratskin Flesh'],
    gwPaints['Rakarth Flesh'],
    gwPaints['Steel Legion Drab'],
    gwPaints['Zandri Dust'],
    gwPaints['Morghast Bone'],
    { name: 'wraithbone', color: '#dbd1b2', company: 'Games Workshop' },

    {
      name: `Skavenblight Dinge`,
      color: '#45413b',
      company: 'Games Workshop',
    },

    {
      name: 'xv88',
      color: '#6c4811',
      company: 'Games Workshop',
    },
    { name: `Stormvermin Fur`, color: '#6d655f', company: 'Games Workshop' },
    { name: `Ushabti Bone`, color: '#aba173', company: 'Games Workshop' },
    { name: `Krieg Khaki`, color: '#bcbb7e', company: 'Games Workshop' },
    { name: `Karak Stone`, color: '#b7945c', company: 'Games Workshop' },
    { name: `Baneblade Brown`, color: '#8f7c68', company: 'Games Workshop' },
    { name: `Gorthor Brown`, color: '#5f463f', company: 'Games Workshop' },
    { name: `Tallarn Sand`, color: '#a07409', company: 'Games Workshop' },
    { name: `Deathclaw Brown`, color: '#af634f', company: 'Games Workshop' },
    { name: `Balor Brown`, color: '#875408', company: 'Games Workshop' },
    { name: `Tau Light Ochre`, color: '#bc6b10', company: 'Games Workshop' },
    { name: `Skrag Brown`, color: '#8b4806', company: 'Games Workshop' },
    { name: `Tuskgor Fur`, color: '#863231', company: 'Games Workshop' },
    { name: `Flayed One Flesh`, color: '#eec483', company: 'Games Workshop' },
    { name: `Ungor Flesh`, color: '#d1a560', company: 'Games Workshop' },
    { name: `Kislev Flesh`, color: '#d1a570', company: 'Games Workshop' },
    { name: `Bestigor Flesh`, color: '#d08951', company: 'Games Workshop' },
    { name: `Cadian Fleshtone`, color: '#c47652', company: 'Games Workshop' },
    {
      name: `Knight-Questor Flesh`,
      color: '#996563',
      company: 'Games Workshop',
    },
    {
      name: `Bloodreaver Flesh`,
      color: '#6a4848',
      company: 'Games Workshop',
    },
  ],

  red: [
    { name: `Doombull Brown`, color: '#570003', company: 'Games Workshop' },
    { name: 'Word Bearers Red', color: '#620104', company: 'Games Workshop' },
    { name: 'Khorne Red', color: '#650001', company: 'Games Workshop' },
    { name: 'Wazdakka Red', color: '#880804', company: 'Games Workshop' },
    {
      name: 'mephistonRed',
      color: '#960b07',
      company: 'Games Workshop',
    },
    {
      name: 'Evil Sunz Scarlet',
      color: '#c01411',
      company: 'Games Workshop',
    },
    { name: 'Wild Rider Red', color: '#e82e1b', company: 'Games Workshop' },
  ],
  metallic: [
    gwPaints['Runelord Brass'],
    gwPaints['Screaming Bell'],
    gwPaints['Balthasar Gold'],
    gwPaints['Iron Warriors'],
    gwPaints['Iron Hands Steel'],
    gwPaints['Grey Knights Steel'],
    {
      name: 'Leadbelcher',
      color: '#848484',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: 'Stormhost Silver',
      color: '#ced2d4',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: 'Runefang Steel',
      color: '#a9afb4',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: 'Ironbreaker',
      color: '#6a7071',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: 'Liberator Gold',
      color: '#c89e5b',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: 'auricArmour',
      color: '#f5b13d',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: `Gehenna's Gold`,
      color: '#b55513',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: `Fulgurite Copper`,
      color: '#c17a3c',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: `Hashut Copper`,
      color: '#a97753',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: `Skullcrusher Brass`,
      color: '#e9b860',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: `Brass Scorpion`,
      color: '#8b431e',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: `Sycorax Bronze`,
      color: '#a28167',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: `Castellax Bronze`,
      color: '#98542c',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: `Canoptek Alloy`,
      color: '#b49b95',
      metal: true,
      company: 'Games Workshop',
    },
    {
      name: 'Retributor Armour',
      color: '#e6b351',
      metal: true,
      company: 'Games Workshop',
    },
  ],
  shade: [
    gwPaints['Nuln Oil'],
    gwPaints['Casandora Yellow'],
    gwPaints['Fuegan Orange'],
    gwPaints['Carroburg Crimson'],
    gwPaints['Druchii Violet'],
    gwPaints['Drakenhof Nightshade'],
    gwPaints['Agrax Earthshade'],
    gwPaints['Coelia Greenshade'],
    gwPaints['Biel-Tan Green'],
    gwPaints['Athonian Camoshade'],
    gwPaints['Seraphim Sepia'],
    gwPaints['Reikland Fleshshade'],
    gwPaints['Apothecary White'],
    gwPaints['None'],
  ],
};

export const basePaints = {
  blue: [],
  turquoise: [],
  purple: [],
  orange: [],
  grey: [],
  green: [],
  brown: [],
  red: [],
  metallic: [],
  shade: [],
};
